<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t('message.Пакеты') }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t('message.Главная') }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t('message.Пакеты') }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">{{ $t('message.Добавить_пакет') }}</b-button>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="viewChannels(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-eye"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button size="sm" @click.stop="deleteRow(row.item, row.index, $event.target)">
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

      <b-modal
        id="modalInfo"
        @hide="resetModal"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Пакеты_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <PackageForm :model="packageModel"></PackageForm>
      </b-modal>
      <b-modal
        id="modalChannels"
        :ok-title="$t('message.Закрыть')"
        :title="$t('message.Список_каналов_-_Просмотр')"
        ok-only
        size="lg"
      >
        <ChannelsListForm :model="packageModelChannels" :type="'packages'"></ChannelsListForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import PackageForm from "./PackageForm";
import ChannelsListForm from "./ChannelListForm";
import Vue from "vue";

export default {
  name: "Packages",
  components: {
    PackageForm,
    ChannelsListForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "comment", sortable: true },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      packageModel: {},
      packageModelChannels: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("packages", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.packageModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteRow(item, index, button) {
      this.$dialog.confirm(this.$i18n.t('message.Действительно_удалить_пакет?')).then(response => {
        this.$noname
          .delete("packages", item.id)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_удалена'),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_удаления_записи') + ':<br>' + error,
              type: "error"
            });
          });
      });
    },
    viewChannels(item, index, button) {
      this.packageModelChannels = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalChannels", button);
    },
    addRow() {
      this.packageModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.packageModel.id > 0) {
        this.$noname
          .patch("packages", this.packageModel.id, this.packageModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("packages", this.packageModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      }
    },
    resetModal() {
      // this.deviceModel = {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Packages.vue